module.exports = __webpack_public_path__ + "static/media/candidate-interview-scheduler-calendar-main.9a1a6ed4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/candidate-interview-scheduler-calendar-main.svg
// module id = 1345
// module chunks = 1